import { useCallback } from "react";
import type { IsoDate } from "../../utils/date";
import { writeInputDate } from "../../utils/date";
import { Calendar } from "../Calendar";
import { useIDatePickerContext } from "./context";

export const DatePickerContent = () => {
  const {
    value,
    maxDate,
    minDate,
    onChange,
    setOpen,
    setDisplayValue,
    focusCalendar,
    locale,
  } = useIDatePickerContext();

  const handleCalendarSelect = useCallback(
    (date: IsoDate) => {
      setDisplayValue(writeInputDate(date, locale.order));
      onChange(date);
      setOpen(false);
    },
    [onChange, setOpen, setDisplayValue, locale.order],
  );

  return (
    <Calendar
      value={value ?? null}
      onChange={handleCalendarSelect}
      min={minDate}
      max={maxDate}
      autoFocus={focusCalendar}
    />
  );
};
